import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import textTypes from '../textLabel/textTypes';
import TextLabel from '../textLabel/textLabel';
var Thumbnail = /*#__PURE__*/function (_React$Component) {
  function Thumbnail(props) {
    var _this;
    _classCallCheck(this, Thumbnail);
    _this = _callSuper(this, Thumbnail, [props]);
    _this.getEllipsisProps = function () {
      return {
        customTrigger: _this,
        displayCustomTrigger: true
      };
    };
    return _this;
  }
  _inherits(Thumbnail, _React$Component);
  return _createClass(Thumbnail, [{
    key: "getIllustrationContainerClasses",
    value: function getIllustrationContainerClasses() {
      return {
        'illustration-container': true,
        'illustration-background': this.props.hasBackground,
        disabled: this.props.disabled,
        'illustration-image': this.props.illustration && this.props.illustration.type === 'img'
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName('control-thumbnail' + (this.props.fixedRatio ? ' fixed-ratio' : '') + (this.props.disabled ? ' disabled' : '')),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, this.props.illustration ? /*#__PURE__*/React.createElement("div", {
        key: "illustration-container",
        className: _(this.getIllustrationContainerClasses()).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' ')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('illustration-inner-container', "thumbnail-skin-".concat(this.props.skin))
      }, this.props.illustration)) : null, this.props.label && this.props.shouldAddTooltipOnEllipsis ? /*#__PURE__*/React.createElement(TextLabel, {
        className: "label",
        value: this.props.label,
        type: this.props.labelType,
        shouldTranslate: this.props.shouldTranslate,
        disabled: this.props.disabled,
        ellipsisProps: this.getEllipsisProps(),
        key: "label"
      }) : null, this.props.label && !this.props.shouldAddTooltipOnEllipsis ? /*#__PURE__*/React.createElement(TextLabel, {
        className: "label",
        key: "noEllipsisLabel",
        value: this.props.label,
        type: this.props.labelType,
        shouldTranslate: this.props.shouldTranslate,
        disabled: this.props.disabled,
        enableEllipsis: false
      }) : null, this.props.children);
    }
  }]);
}(React.Component);
Thumbnail.displayName = displayNames.THUMBNAIL;
Thumbnail.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** value */
  value: PropTypes.string.isRequired,
  /** label */
  label: PropTypes.string,
  /** labelType */
  labelType: PropTypes.string,
  /** hasBackground */
  hasBackground: PropTypes.bool,
  /** illustration */
  illustration: PropTypes.element,
  /** fixedRatio */
  fixedRatio: PropTypes.bool,
  /** shouldAddTooltipOnEllipsis */
  shouldAddTooltipOnEllipsis: PropTypes.bool,
  /** disabled */
  disabled: PropTypes.bool,
  /** skin */
  skin: PropTypes.oneOf(['standard', 'transparent'])
};
Thumbnail.defaultProps = {
  labelType: textTypes.THUMBNAIL_LABEL_DEFAULT_TYPE,
  hasBackground: true,
  shouldAddTooltipOnEllipsis: true,
  skin: 'standard'
};
export default compose(Thumbnail);